import * as React from "react";
import { scrollToElement } from "../helpers/helper/index.mjs";
const _Autoscroll = class _Autoscroll extends React.PureComponent {
  enhanceItem(child) {
    if (child !== null && child !== void 0) {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          onClick: (event) => {
            event.preventDefault();
            const element = document.getElementById(this.props.id);
            const hashEvent = new CustomEvent("hashchange", {
              detail: {
                // disable scroll in hashtrigger if element is in dom and autoscroll should trigger scrolling
                fromAutoscroll: !!element
              }
            });
            history.pushState(null, "", "#" + this.props.id);
            window.dispatchEvent(hashEvent);
            if (element) {
              scrollToElement(this.props.id, this.props.speed, this.props.offset, true);
            }
            if (this.props.onClick) {
              this.props.onClick(event);
            }
          },
          url: "#" + this.props.id
        });
      }
    }
  }
  render() {
    const children = React.Children.map(this.props.children, this.enhanceItem.bind(this));
    const child = children && children.length ? children[0] : null;
    return child ? React.Children.only(child) : null;
  }
};
_Autoscroll.defaultProps = {
  offset: 50,
  speed: 500
};
let Autoscroll = _Autoscroll;
export {
  Autoscroll
};
